import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import moment from 'moment-timezone';
import { MomentModule } from 'ngx-moment';

import { TimeAgoPipe } from '@core/time-legacy';
import {
  ComponentVariant,
  RtTooltip,
  TooltipPosition,
  Variants,
} from '@core/user-interface-legacy';

type RtTimeAgoOptions = Parameters<TimeAgoPipe['transform']>[1];

@Component({
  selector: 'rt-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
  imports: [RtTooltip, MomentModule, TimeAgoPipe, LowerCasePipe],
})
export class DateComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    ['default', 'small', 'large', 'left-align', 'color-red', 'no-wrap'],
  ];
  @ComponentVariant(DateComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public time: number | string;
  @Input() public tiny: boolean = false;
  @Input() public tinyWithSuffix: boolean = false;
  @Input() public prefix: string | undefined;
  @Input() public tooltipPosition: TooltipPosition = 'above';
  @Input() public colorDarkest: boolean = false;
  @Input() public amDateFormatPattern: string = 'lll';
  @Input() public capitalize: boolean = true;

  public timeAgoOptions: RtTimeAgoOptions = undefined;

  public ngOnChanges(): void {
    this.timeAgoOptions = this.getTimeAgoOptions();
  }

  private getTimeAgoOptions(): RtTimeAgoOptions {
    const isFuture = moment(this.time).isAfter(moment());

    if (this.tiny) {
      return { omitSuffix: !isFuture, shortWithSuffix: false };
    } else if (this.tinyWithSuffix) {
      return { omitSuffix: false, shortWithSuffix: true };
    }

    return undefined;
  }
}
